<template>
  <div class="footer-btn van-safe-area-bottom">
    <div ref="footerBtnDom" class="box">
      <slot></slot>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useElementBounding } from '@vueuse/core';

const footerBtnDom = ref(null);
const { height } = useElementBounding(footerBtnDom);

defineExpose({
  height,
});
</script>

<style lang="less" scoped>
@import '@/styles/mixins/clearfix.less';

.footer-btn {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 9;
  background: #fff;

  .box {
    padding: 16px 32px;
    .clearfix();
  }

  :deep(.van-action-bar) {
    position: relative;
    height: auto;
  }

  :deep(.van-safe-area-bottom) {
    padding-bottom: 0;
  }
}
</style>
